<template>
  <div class="page-content-wrap">
    <FileFullPreviewMode></FileFullPreviewMode>
    <div
      v-for="(attribute, index) in service.data_list"
      :key="index"
      class="row row-service"
    >
      <!--
      /*
      * Label column
      */
      -->

      <!-- Label - text -->
      <div
        v-if="attribute.type == 'text' && attribute.valueLang[`${$app.lang}`]"
        class="col-xs-12 col-md-4 col-name"
      >
        {{ attribute.name[`${$app.lang}`] }}
      </div>

      <!--  Label - text area -->
      <div
        v-if="
          attribute.type == 'textarea' && attribute.valueLang[`${$app.lang}`]
        "
        class="col-xs-12 col-md-4 col-name"
      >
        {{ attribute.name[`${$app.lang}`] }}
      </div>

      <!--  Label - wysiwyg -->
      <div
        v-if="
          attribute.type == 'wysiwyg' && attribute.valueLang[`${$app.lang}`]
        "
        class="col-xs-12 col-md-4 col-name"
      >
        {{ attribute.name[`${$app.lang}`] }}
      </div>

      <!--  Label - number -->
      <div
        v-if="
          attribute.type == 'number' &&
          (attribute.valueNumeric || attribute.valueNumeric == 0)
        "
        class="col-xs-12 col-md-4 col-name"
      >
        {{ attribute.name[`${$app.lang}`] }}
      </div>

      <!--  Label - file -->
      <div
        v-if="
          attribute.type == 'file' &&
          attribute.hasOwnProperty('files') &&
          Object.keys(attribute.files).length != 0
        "
        class="col-xs-12 col-md-4 col-name"
      >
        {{ getAttributeLangValue(attribute, 'name', $app.lang) }}
      </div>

      <!--  Label - image -->
      <div
        v-if="
          attribute.type == 'image' &&
          attribute.hasOwnProperty('files') &&
          Object.keys(attribute.files).length != 0
        "
        class="col-xs-12 col-md-4 col-name"
      >
        {{ getAttributeLangValue(attribute, 'name', $app.lang) }}
      </div>

      <!--  Label - url -->
      <div
        v-if="
          attribute.type == 'url' &&
          attribute.hasOwnProperty('options') &&
          Object.keys(attribute.options).length != 0 &&
          attribute.options != 'undefined'
        "
        class="col-xs-12 col-md-4 col-name"
      >
        {{ attribute.name[`${$app.lang}`] }}
      </div>

      <!--  Label - internet -->
      <div
        v-if="attribute.type == 'service_online'"
        class="col-xs-12 col-md-4 col-name"
      >
        Paslauga teikiama internetu
      </div>

      <!--  Label - categories -->
      <div
        v-if="
          attribute.type == 'service_categories' &&
          service.hasOwnProperty('service_categories') &&
          service.service_categories
        "
        class="col-xs-12 col-md-4 col-name"
      >
        Paslaugos kategorija
      </div>

      <!--  Label - lifecase -->
      <div
        v-if="
          attribute.type == 'service_life_cases' &&
          service.hasOwnProperty('service_cases') &&
          service.service_cases
        "
        class="col-xs-12 col-md-4 col-name"
      >
        Gyvenimo atvejas
      </div>

      <!--  Label - duration -->
      <div
        v-if="attribute.type == 'service_duration' && service.term_max"
        class="col-xs-12 col-md-4 col-name"
      >
        Paslaugos suteikimo trukmė
      </div>

      <!--  Label - price -->
      <div
        v-if="attribute.type == 'service_price'"
        class="col-xs-12 col-md-4 col-name"
      >
        Paslaugos kaina
      </div>

      <!--  Label - recipients -->
      <div
        v-if="
          attribute.type == 'service_recipient' &&
          (service.dedicated_individual == 1 || service.dedicated_legal == 1)
        "
        class="col-xs-12 col-md-4 col-name"
      >
        Paslaugos gavėjas
      </div>

      <!--  Label - departments -->
      <div
        v-if="
          attribute.type == 'service_department' && service.service_departments
        "
        class="col-xs-12 col-md-4 col-name"
      >
        Atsakingas padalinys
      </div>

      <!--  Label - contacts -->
      <div
        v-if="attribute.type == 'service_contacts' && service.service_contacts"
        class="col-xs-12 col-md-4 col-name"
      >
        Paslaugos vykdytojas
      </div>

      <!--  Label - updated at -->
      <div
        v-if="attribute.type == 'service_updated_at' && service.date_updated_at"
        class="col-xs-12 col-md-4 col-name"
      >
        Informacija atnaujinta
      </div>

      <!-- ----------------------------------------------------------------------------------- -->

      <!--
      /*
      * Value column
      */
      -->

      <!-- Value - text -->
      <div
        v-if="attribute.type == 'text' && attribute.valueLang[`${$app.lang}`]"
        class="col-xs-12 col-md-8 col-value"
      >
        {{ attribute.valueLang[`${$app.lang}`] }}
      </div>

      <!-- Value - text area -->
      <div
        v-if="
          attribute.type == 'textarea' && attribute.valueLang[`${$app.lang}`]
        "
        class="col-xs-12 col-md-8 col-value"
      >
        {{ attribute.valueLang[`${$app.lang}`] }}
      </div>

      <!-- Value - wysiwyg -->
      <div
        v-if="
          attribute.type == 'wysiwyg' && attribute.valueLang[`${$app.lang}`]
        "
        class="col-xs-12 col-md-8 col-value"
        v-html="attribute.valueLang[`${$app.lang}`]"
      ></div>

      <!-- Value - number -->
      <div
        v-if="
          attribute.type == 'number' &&
          (attribute.valueNumeric || attribute.valueNumeric == 0)
        "
        class="col-xs-12 col-md-8 col-value"
      >
        {{ attribute.valueNumeric }}
      </div>

      <!-- Value - files -->
      <div
        v-if="
          attribute.type == 'file' &&
          attribute.hasOwnProperty('files') &&
          Object.keys(attribute.files).length != 0
        "
        class="col-xs-12 col-md-8 col-value"
      >
        <file-preview
          :folder="attribute.unique_folder_id"
          :show-file-name="attribute.show_file_name"
          :show-file-size="attribute.show_file_size"
          :show-file-extension="attribute.show_file_extension"
        ></file-preview>
        <!--        <FileBrowser
          :unique-folder-id="attribute.unique_folder_id"
          :records="getPublicFolder(attribute.unique_folder_id)"
        ></FileBrowser>-->
      </div>

      <!-- Value - image -->
      <div
        v-if="
          attribute.type == 'image' &&
          attribute.hasOwnProperty('files') &&
          Object.keys(attribute.files).length != 0
        "
        class="col-xs-12 col-md-8 col-value"
      >
        <file-preview
          :folder="attribute.unique_folder_id"
          :show-file-name="attribute.show_file_name"
          :show-file-size="attribute.show_file_size"
          :show-file-extension="attribute.show_file_extension"
        ></file-preview>
        <!--        <FileBrowser
          :records="attribute.files"
          :unique-folder-id="attribute.unique_folder_id"
          file-preview-type="grid"
        ></FileBrowser>-->
        <!--<FileBrowser
          :init="getPublicFolder(attribute.unique_folder_id)"
          :records="records"
        ></FileBrowser>-->
      </div>

      <!-- Value - url  -->
      <div
        v-if="
          attribute.type == 'url' &&
          attribute.hasOwnProperty('options') &&
          Object.keys(attribute.options).length != 0 &&
          attribute.options != 'undefined'
        "
        class="col-xs-12 col-md-8 col-value"
      >
        <div
          v-for="(option, indexUrl) in attribute.options"
          :key="indexUrl"
          class="url-block"
        >
          <a :href="option.content" target="_blank" class="url-block-link">
            <span class="url-block-icon"><i class="fas fa-link"></i></span>
            <span class="url-block-label">{{ option.text }}</span>
          </a>
        </div>
      </div>

      <!-- Value - internet  -->
      <div
        v-if="attribute.type == 'service_online'"
        class="col-xs-12 col-md-8 col-value"
      >
        <template v-if="service.online_service == 1">
          <template v-if="service.external_service != 1">
            <a
              v-if="$app.isLoggedIn"
              class="btn btn-primary blue"
              :href="`${service.form_url}`"
            >
              Užsakyti paslaugą internetu
            </a>
            <div
              v-if="!$app.isLoggedIn"
              class="btn btn-primary blue"
              @click="modalAuthDialog()"
            >
              {{ $t('account.nav.login') }}
            </div>
          </template>
          <template v-else>
            <template v-if="service.external_url">
              <a
                class="btn btn-primary blue"
                :href="`${service.external_url}`"
                target="_blank"
              >
                Prisijungti
              </a>
            </template>
            <template v-else> Ne </template>
          </template>
        </template>
        <template v-else> Ne </template>
      </div>

      <!--  Value - categories -->
      <div
        v-if="
          attribute.type == 'service_categories' &&
          service.hasOwnProperty('service_categories') &&
          service.service_categories
        "
        class="col-xs-12 col-md-8 col-value"
      >
        {{ service.service_categories }}
      </div>

      <!--  Value - life cases -->
      <div
        v-if="
          attribute.type == 'service_life_cases' &&
          service.hasOwnProperty('service_cases') &&
          service.service_cases
        "
        class="col-xs-12 col-md-8 col-value"
      >
        {{ service.service_cases }}
      </div>

      <!--  Value - duration -->
      <div
        v-if="attribute.type == 'service_duration' && service.term_max"
        class="col-xs-12 col-md-8 col-value"
      >
        {{ service.term_max }} {{ service.term_format }}
      </div>

      <!--  Value - price -->
      <div
        v-if="attribute.type == 'service_price'"
        class="col-xs-12 col-md-8 col-value"
      >
        <template v-if="service.user_price_enabled">
          Mokama Jūsų nurodyta suma
        </template>

        <template v-else>
          <template v-if="service.price > 0">
            {{ service.price > 0 ? service.price / 100 : '' }} EUR
          </template>
          <template v-else> Nemokamai </template>
        </template>
      </div>

      <!--  Value - recipients -->
      <div
        v-if="
          attribute.type == 'service_recipient' &&
          (service.dedicated_individual == 1 || service.dedicated_legal == 1)
        "
        class="col-xs-12 col-md-8 col-value"
      >
        <template
          v-if="
            service.dedicated_individual == 1 && service.dedicated_legal == 1
          "
        >
          Fizinis arba juridinis asmuo
        </template>

        <template
          v-if="
            service.dedicated_individual == 1 && service.dedicated_legal != 1
          "
        >
          Fizinis asmuo
        </template>

        <template
          v-if="
            service.dedicated_individual != 1 && service.dedicated_legal == 1
          "
        >
          Juridinis asmuo
        </template>
      </div>

      <!--  Value - departments -->
      <div
        v-if="attribute.type == 'service_department'"
        class="col-xs-12 col-md-8 col-value"
      >
        <template v-if="service.service_departments">
          <div
            v-for="(dep, dix) in service.service_departments"
            :key="dix"
            class="contact-row"
          >
            <template v-if="dep.website">
              <a class="service-link" :href="dep.website" target="_blank">
                {{ dep.name }}
              </a>
            </template>
            <template v-else>
              {{ dep.name }}
            </template>
          </div>
        </template>
      </div>

      <!--  Value - contacts -->
      <div
        v-if="attribute.type == 'service_contacts'"
        class="col-xs-12 col-md-8 col-value"
      >
        <template v-if="service.service_contacts">
          <div
            v-for="(contact, cix) in service.service_contacts"
            :key="cix"
            class="contact-row"
          >
            <template v-if="contact.email">
              <a :href="`mailto:${contact.email}`" class="service-link">
                {{ contact.first_name }} {{ contact.last_name }}
              </a>
            </template>
            <template v-else>
              {{ contact.first_name }} {{ contact.last_name }}
            </template>

            <template v-if="contact.phone">
              ,
              <a
                :href="`tel:${contact.phone}`"
                class="service-link service-link-phone"
              >
                {{ contact.phone }}
              </a>
            </template>
          </div>
        </template>
      </div>

      <!--  Value - updated at -->
      <div
        v-if="attribute.type == 'service_updated_at' && service.date_updated_at"
        class="col-xs-12 col-md-8 col-value"
      >
        {{ service.date_updated_at }}
      </div>

      <!-- ----------------------------------------------------------------------------------- -->
    </div>
    <!--    <div class="row row-service">
      <div class="col-xs-12 col-md-4 col-name">
        Paslauga teikiama internetu
      </div>

      <div class="col-xs-12 col-md-8 col-value">
        <a
          class="btn btn-primary blue"
          :href="`${service.form_url}`"
          v-if="this.$app.isLoggedIn"
        >
          Užsakyti paslaugą internetu
        </a>
        <div
          class="btn btn-primary blue"
          @click="modalAuthDialog()"
          v-if="!this.$app.isLoggedIn"
        >
          {{ $t('account.nav.login') }}
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import AuthDialog from '@account/js/components/modals/AuthDialog.vue'
import FilePreview from '@assets/js/views/Preview/FilePreview'
import FileFullPreviewMode from '@assets/js/components/Preview/FileFullPreviewMode'
export default {
  name: 'ServicePage',
  title: '',
  components: {
    FilePreview,
    FileFullPreviewMode,
  },
  props: {
    service: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: {
        records: [],
      },
    }
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    modalAuthDialog() {
      this.$modal.show(
        AuthDialog,
        {
          id: this.service.id,
          modal: true,
        },
        {
          name: 'auth-modal',
          clickToClose: false,
          resizable: false,
          adaptive: true,
          draggable: false,
          scrollable: true,
          height: 'auto',
          maxWidth: 780,
          width: '100%',
          transition: 'nice-modal-fade',
        },
      )
    },
    getAttributeLangValue(data, param, lang = null) {
      if (!lang && data.hasOwnProperty(param)) {
        return this.data[param]
      }

      if (lang && data.hasOwnProperty(param)) {
        let value = data[param]
        if (value && value.hasOwnProperty(lang)) {
          return value[lang]
        }
        return value
      }

      return ''
    },
    getAttributeValue(param, lang = null) {
      if (!lang && this.data.hasOwnProperty(param)) {
        return this.data[param]
      }
      if (lang && this.data.hasOwnProperty(param)) {
        let value = this.data[param]
        if (value && value.hasOwnProperty(lang)) {
          return value[lang]
        }
        return value
      }
      return ''
    },
    getPublicFolder(unique_folder_id) {
      // const isValid = await this.$refs.sign_up.validate()
      let loading = false
      let records = []

      if (unique_folder_id) {
        loading = true
        this.$store
          .dispatch('services/getPublicFolder', {
            unique_folder_id: unique_folder_id,
          })
          .then((response) => {
            loading = false
            records = response
            //this.records[unique_folder_id] = response.data
            ///return response
          })
      }
      /*      if (unique_folder_id) {
        if (!this.data.status.hasOwnProperty(unique_folder_id)) {
          let item = {
            id: unique_folder_id,
            name: '',
            value: '',
            enabled: true
          }
          this.data.status.push(item)
        }
        console.log(unique_folder_id)
        /!*        this.$store
          .dispatch('services/getPublicFolder', {
            unique_folder_id: unique_folder_id
          })
          .then(response => {
            this.records[unique_folder_id] = response.data
          })*!/
      }*/
      if (!loading) {
        // console.log(records)
        return records
      }
    },
  },
}
</script>
